import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import "./index.css";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import ReactGA from "react-ga4";
import * as serviceWorker from "./serviceWorker";

import "./fonts/Osaka/osaka-re.ttf";
import "./fonts/DccDreamer/dcc-dreamer.otf";

ReactGA.initialize("G-VDQX00994W", {
  gaOptions: {
    anonymizeIp: true,
  },
});

ReactDOM.render(
  //@ts-ignore
  <React.StrictMode>
    <Router>
      {/* @ts-ignore */}
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
